export default __webpack_public_path__ + "static/media/tomas-nosotros.ae76d8ac.jpeg";